<template>
  <section class="dp-layout mr-page-layout">
    <section class="dp-right mr-module mr-table-layout">
      <div class="page-header">
        <div>
          <div class="header-title-bar">
            <span class="header-icon-bar"></span>
            <h3>审批流程配置</h3>
          </div>
          <p class="page-desc">按学校/校区配置审批链路；可再细化到具体会议室</p>
        </div>
        <el-tag v-if="schoolName" type="success" size="medium" effect="plain" class="school-badge">
          <i class="el-icon-school"></i> {{ schoolName }}
        </el-tag>
        <span v-else-if="!schoolId" class="school-hint">请在顶部选择学校</span>
      </div>

      <div v-if="!schoolId" class="mr-empty">
        <div class="mr-empty__icon"><i class="el-icon-office-building"></i></div>
        <div class="mr-empty__text">请在顶部选择学校后配置审批流程</div>
      </div>

      <template v-else>
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

            <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
            <div class="tbl-scroll-host">
            <el-table height="100%" :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
        ref="table" class="custom-tbl mr-table" style="width: 100%">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="Name" label="流程名称" width></el-table-column>
        <el-table-column prop="UsingTypeStr" label="应用类型" width=""></el-table-column>
        <el-table-column label="适用会议室" width="">
          <template slot-scope="scope">{{ scope.row.LeaveTypeName || '全校通用' }}</template>
        </el-table-column>     
        <el-table-column prop="DepartmentName" label="学校" width></el-table-column>
        <el-table-column label="校区" width="">
          <template slot-scope="scope">{{ scope.row.GradeName || '全校' }}</template>
        </el-table-column>
        <el-table-column prop="Sort" label="序号" width="70"></el-table-column>
        <el-table-column prop="CreateTime" label="添加时间" width="180"></el-table-column>
        <el-table-column fixed="right" label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button @click="showAddApprovalNode(scope.row)" type="text">审批人员设置</el-button>
          </template>
        </el-table-column>
      </el-table>
            </div>

      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :current-page="page" :page-size="10" :total="total" style="float: right" />
      </el-col>

      <!-- 编辑 -->
      <el-dialog title="编辑会议室审批流程" :visible.sync="editFormVisible" :close-on-click-modal="false" destroy-on-close custom-class="mr-module">
        <el-form :model="editForm" label-width="110px" :rules="formRules" ref="editForm">
          <el-form-item label="名称" prop="Name">
            <el-input v-model="editForm.Name"></el-input>
          </el-form-item>
          <el-form-item label="校区" prop="GradeId">
            <el-select v-model="editForm.GradeId" placeholder="请选择校区" style="width: 100%;"
              @change="onFormCampusChange('editForm')">
              <el-option label="全校" :value="allCampusFormValue" />
              <el-option v-for="item in campusOptions" :key="item.id" :label="item.label" :value="item.id" />
            </el-select>
            <div v-if="!campusOptions.length" class="mr-field-tip">当前学校下暂无校区，可选「全校」</div>
          </el-form-item>
          <el-form-item label="适用会议室">
            <el-select v-model="editForm.LeaveTypeId" placeholder="不选表示该校/校区通用" clearable filterable style="width: 100%;">
              <el-option v-for="item in roomsForForm(editForm.GradeId)" :key="String(item.Id)"
                :label="roomOptionLabel(item)" :value="normalizeOptionalIdString(item.Id)" />
            </el-select>
          </el-form-item>
          <el-form-item label="序号" prop="Sort">
            <el-input-number v-model="editForm.Sort" :min="1" style="width: 120px;"></el-input-number>
            <span class="mr-field-tip inline">同范围多条流程时取序号最小的执行</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 新增 -->
      <el-dialog title="新增会议室审批流程" :visible.sync="addFormVisible" :close-on-click-modal="false" destroy-on-close custom-class="mr-module">
        <el-form :model="addForm" label-width="110px" :rules="formRules" ref="addForm">
          <el-form-item label="名称" prop="Name">
            <el-input v-model="addForm.Name"></el-input>
          </el-form-item>
          <el-form-item label="校区" prop="GradeId">
            <el-select v-model="addForm.GradeId" placeholder="请选择校区" style="width: 100%;"
              @change="onFormCampusChange('addForm')">
              <el-option label="全校" :value="allCampusFormValue" />
              <el-option v-for="item in campusOptions" :key="item.id" :label="item.label" :value="item.id" />
            </el-select>
            <div v-if="!campusOptions.length" class="mr-field-tip">当前学校下暂无校区，可选「全校」</div>
          </el-form-item>
          <el-form-item label="适用会议室">
            <el-select v-model="addForm.LeaveTypeId" placeholder="不选表示该校/校区通用" clearable filterable style="width: 100%;">
              <el-option v-for="item in roomsForForm(addForm.GradeId)" :key="String(item.Id)"
                :label="roomOptionLabel(item)" :value="normalizeOptionalIdString(item.Id)" />
            </el-select>
          </el-form-item>
          <el-form-item label="序号" prop="Sort">
            <el-input-number v-model="addForm.Sort" :min="1" style="width: 120px;"></el-input-number>
            <span class="mr-field-tip inline">同范围多条流程时取序号最小的执行</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 审批节点（复用 LeaveApprovalProcess + ProcessOfficer，与报修审批流相同） -->
      <el-dialog title="审批人员设置" width="65%" :visible.sync="addApprovalNodeVisible"
        :close-on-click-modal="false" center destroy-on-close custom-class="mr-module">
        <div v-if="approvalCampusLabel" class="mr-approval-scope-hint">
          <i class="el-icon-info"></i>
          可选审批人范围：<strong>{{ approvalCampusLabel }}</strong>
          <span v-if="approvalCampusId > 0">（已按流程校区过滤，与 H5 预约匹配一致）</span>
          <span v-else>（全校流程，可选本校全部教职工）</span>
        </div>
        <el-table v-if="addApprovalNodeVisible" :data="approvalNodes" style="width: 100%;" class="mr-table">
          <el-table-column prop="index" label="序号" width="80" align="center"></el-table-column>
          <el-table-column label="节点信息">
            <template slot-scope="scope">
              <el-form :inline="true" :model="scope.row">
                <el-form-item>
                  <el-select v-model="scope.row.role" style="width: 180px;" placeholder="请选择角色"
                    @change="roleChange(scope.$index)">
                    <el-option v-for="item in meetingRoleOptions" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="scope.row.role === 'specificPerson'">
                  <el-select v-model="scope.row.specificUsers" multiple filterable
                    placeholder="请选择或输入审批人员" style="min-width: 280px;"
                    @change="specificUsersChange(scope.$index)">
                    <el-option v-for="user in userList" :key="String(user.Id)"
                      :label="teacherOptionLabel(user)" :value="String(user.Id)"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="scope.row.nodeName" placeholder="节点名称" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="danger" @click="removeNode(scope.$index)">删除</el-button>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addNode">添加节点</el-button>
          <el-button type="primary" @click="submitApprovalNodes">保存</el-button>
          <el-button @click="addApprovalNodeVisible = false">取消</el-button>
        </div>
      </el-dialog>
      </template>
    </section>
  </section>
</template>

<script>
import { getLeaveApprovalProcessListPage, removeLeaveApprovalProcess, editLeaveApprovalProcess, addLeaveApprovalProcess, getProcessOfficer, addProcessOfficer, getMeetingRoomListPage } from '../../api/modules/misc';
import { getTeacherMasterList } from '../../api/modules/personnel';
import { getCampusList } from '../../api/meetingRoomApi';
import { getButtonList } from '../../utils/routeButtonList';
import { normalizeOptionalIdString, toOptionalIdPayload, normalizeGradeIdForForm, gradeIdToPayload, gradeIdToFilterNumber, ALL_CAMPUS_FORM_VALUE } from '../../utils/meetingRoomForm';
import { resolveActiveSchoolId, normalizeDeptId, deptIdsEqual } from '../../utils/deptCascaderProps';
import Toolbar from '../../components/Toolbar';

export default {
  components: { Toolbar },
  data() {
    return {
      allCampusFormValue: ALL_CAMPUS_FORM_VALUE,
      filters: {},
      campusOptions: [],
      searchList: [{ label: '名称', key: 'name' }],
      users: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      meetingRoomList: [],
      editFormVisible: false,
      editLoading: false,
      addFormVisible: false,
      addLoading: false,
      formRules: {
        Name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      },
      editForm: {},
      addForm: {},
      processId: '',
      addApprovalNodeVisible: false,
      approvalNodes: [],
      approvalCampusId: 0,
      approvalCampusLabel: '',
      userList: [],
      meetingRoleOptions: [
        { label: '指定人员', value: 'specificPerson' }
      ]
    };
  },
  computed: {
    schoolId() {
      return resolveActiveSchoolId(this);
    },
    schoolName() {
      return this.$store.state.activeSchoolName || '';
    }
  },
  watch: {
    schoolId(val, oldVal) {
      if (val === oldVal) return;
      this.onSchoolChanged(val);
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    if (this.schoolId) this.onSchoolChanged(this.schoolId);
  },
  methods: {
    parseSpecificUserIds(raw) {
      if (!raw) return [];
      return String(raw).split(/[|/,，、]/).map(s => s.trim()).filter(Boolean);
    },
    ensureUserOptions(ids, nodeName) {
      const existIds = new Set(this.userList.map(u => String(u.Id)));
      const names = (nodeName || '').replace(/审批$/, '').split(/[、,，/|]/).map(s => s.trim()).filter(Boolean);
      ids.forEach((id, idx) => {
        const sid = String(id);
        if (!existIds.has(sid)) {
          this.userList.push({ Id: sid, TeacherName: names[idx] || names[0] || `教职工(${sid})` });
          existIds.add(sid);
        }
      });
    },
    async loadTeacherOptions(departmentId, campusId) {
      const params = { departmentId };
      if (campusId > 0) params.campusId = campusId;
      const res = await getTeacherMasterList(params);
      if (res.data && res.data.success) {
        this.userList = res.data.response || [];
      } else {
        this.userList = [];
      }
    },
    loadCampusOptions() {
      const schoolId = normalizeDeptId(this.schoolId);
      if (!schoolId) {
        this.campusOptions = [];
        return Promise.resolve();
      }
      return getCampusList({ page: 1, intPageSize: 999, departmentId: schoolId }).then(res => {
        if (!deptIdsEqual(this.schoolId, schoolId)) return;
        if (!res.data.success) {
          this.campusOptions = [];
          return;
        }
        const response = res.data.response || {};
        const rows = Array.isArray(response.data) ? response.data : [];
        this.campusOptions = rows.map(item => ({
          id: Number(item.Id || item.id),
          label: item.Name || item.name || ''
        })).filter(item => item.id > 0);
      }).catch(() => {
        if (deptIdsEqual(this.schoolId, schoolId)) this.campusOptions = [];
      });
    },
    roomsForForm(gradeId) {
      const campusId = gradeIdToFilterNumber(gradeId);
      if (!campusId) return this.meetingRoomList;
      return this.meetingRoomList.filter(r => !Number(r.CampusId) || Number(r.CampusId) === campusId);
    },
    roomOptionLabel(room) {
      if (!room.CampusName) return room.Name;
      return `${room.Name}（${room.CampusName}）`;
    },
    onFormCampusChange(formKey) {
      const form = this[formKey];
      if (!form || !form.LeaveTypeId) return;
      const allowed = this.roomsForForm(form.GradeId).some(
        r => String(r.Id) === String(form.LeaveTypeId)
      );
      if (!allowed) form.LeaveTypeId = null;
    },
    /** 解析审批人可选校区：流程校区 > 绑定会议室校区 > 全校 */
    resolveApprovalCampusId(row) {
      if (!row) return 0;
      const gradeId = Number(row.GradeId) || 0;
      if (gradeId > 0) return gradeId;
      const roomId = normalizeOptionalIdString(row.LeaveTypeId);
      if (roomId) {
        const room = this.meetingRoomList.find(r => String(r.Id) === roomId);
        if (room && Number(room.CampusId) > 0) return Number(room.CampusId);
      }
      return 0;
    },
    resolveApprovalCampusLabel(campusId) {
      if (!campusId) return '全校教职工';
      const hit = this.campusOptions.find(c => c.id === campusId);
      return hit ? `${hit.label} 教职工` : '指定校区教职工';
    },
    teacherOptionLabel(user) {
      return user.TeacherName || `教职工(${user.Id})`;
    },
    normalizeOptionalIdString,
    loadMeetingRooms(departmentId) {
      return getMeetingRoomListPage({ page: 1, intPageSize: 200, departmentId }).then(res => {
        if (res.data && res.data.success) {
          this.meetingRoomList = res.data.response.data || [];
        }
      });
    },
    handleQuery() {
      if (!this.schoolId) return;
      const para = {
        page: this.page,
        departmentId: this.schoolId,
        usingTypes: 'meeting_room',
        ...this.filters
      };
      this.listLoading = true;
      getLeaveApprovalProcessListPage(para).then(res => {
        this.total = res.data.response.dataCount;
        const list = res.data.response.data || [];
        list.forEach(item => {
          item.UsingTypeStr = '会议室预约审批';
          const room = this.meetingRoomList.find(r => String(r.Id) === String(item.LeaveTypeId));
          item.LeaveTypeName = room ? room.Name : '';
        });
        this.users = list;
        this.listLoading = false;
      }).catch(() => { this.listLoading = false; });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    onSchoolChanged(schoolId) {
      this.currentRow = null;
      if (!schoolId) {
        this.users = [];
        this.total = 0;
        this.meetingRoomList = [];
        return;
      }
      this.page = 1;
      Promise.all([
        this.loadCampusOptions(),
        this.loadMeetingRooms(schoolId)
      ]).then(() => this.handleQuery());
    },
    callFunction(item) {
      if (typeof item.search === 'object') {
        this.filters = item.search;
      } else {
        this.filters = { name: item.search };
      }
      if (item.Func) {
        this[item.Func].apply(this, item);
      }
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length && row) this.selectCurrentRow(row);
    },
    selectCurrentRow(val) {
      if (!val) return;
      this.currentRow = val;
      this.$refs.table.clearSelection();
      this.$nextTick(() => this.$refs.table.toggleRowSelection(val, true));
    },
    handleAdd() {
      this.addForm = {
        Name: '',
        UsingType: 'meeting_room',
        LeaveTypeId: null,
        Sort: 1,
        DepartmentId: this.schoolId || '',
        GradeId: ALL_CAMPUS_FORM_VALUE
      };
      this.addFormVisible = true;
    },
    addSubmit() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return;
        this.addLoading = true;
        addLeaveApprovalProcess({
          ...this.addForm,
          GradeId: gradeIdToPayload(this.addForm.GradeId),
          LeaveTypeId: toOptionalIdPayload(this.addForm.LeaveTypeId)
        }).then(res => {
          this.addLoading = false;
          if (res.data.success) {
            this.$message.success('新增成功');
            this.addFormVisible = false;
            this.handleQuery();
          } else {
            this.$message.error(res.data.msg || '新增失败');
          }
        }).catch(() => { this.addLoading = false; });
      });
    },
    handleEdit() {
      if (!this.currentRow) {
        this.$message.warning('请先选择要编辑的记录');
        return;
      }
      const row = this.currentRow;
      this.editForm = {
        Id: row.Id,
        Name: row.Name,
        UsingType: row.UsingType,
        // 雪花 Id 用字符串，与 option value 类型一致，避免 el-select 回显成裸 Id
        LeaveTypeId: normalizeOptionalIdString(row.LeaveTypeId),
        Sort: row.Sort || 1,
        DepartmentId: row.DepartmentId || 0,
        GradeId: normalizeGradeIdForForm(row.GradeId)
      };
      this.editFormVisible = true;
    },
    editSubmit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;
        this.editLoading = true;
        editLeaveApprovalProcess({
          ...this.editForm,
          GradeId: gradeIdToPayload(this.editForm.GradeId),
          LeaveTypeId: toOptionalIdPayload(this.editForm.LeaveTypeId)
        }).then(res => {
          this.editLoading = false;
          if (res.data.success) {
            this.$message.success('修改成功');
            this.editFormVisible = false;
            this.handleQuery();
          } else {
            this.$message.error(res.data.msg || '修改失败');
          }
        }).catch(() => { this.editLoading = false; });
      });
    },
    handleDel() {
      if (!this.currentRow) {
        this.$message.warning('请先选择要删除的记录');
        return;
      }
      this.$confirm('确认删除该审批流程？', '提示', { type: 'warning' }).then(async () => {
        const res = await removeLeaveApprovalProcess({ id: this.currentRow.Id });
        if (res.data.success) {
          this.$message.success('删除成功');
          this.currentRow = null;
          this.handleQuery();
        } else {
          this.$message.error(res.data.msg || '删除失败');
        }
      }).catch(() => {});
    },
    async showAddApprovalNode(row) {
      this.processId = row.Id;
      this.approvalNodes = [];
      this.approvalCampusId = this.resolveApprovalCampusId(row);
      this.approvalCampusLabel = this.resolveApprovalCampusLabel(this.approvalCampusId);
      this.addApprovalNodeVisible = true;
      try {
        await this.loadTeacherOptions(row.DepartmentId, this.approvalCampusId);
        const res = await getProcessOfficer({ processId: row.Id });
        if (res.data && res.data.success) {
          const nodes = res.data.response || [];
          this.approvalNodes = nodes.map((n, i) => {
            const specificUsers = this.parseSpecificUserIds(n.SpecificPerson || n.specificPerson);
            this.ensureUserOptions(specificUsers, n.NodeName || n.nodeName);
            return {
              index: n.Index || n.index || (i + 1),
              nodeName: n.NodeName || n.nodeName || '',
              role: n.Role || n.role || 'specificPerson',
              specificUsers: specificUsers.map(id => String(id))
            };
          });
          if (!this.approvalNodes.length) this.addNode();
        }
      } catch (e) {
        this.$message.error('加载审批人员失败');
      }
    },
    addNode() {
      const nextIndex = this.approvalNodes.length
        ? Math.max(...this.approvalNodes.map(n => n.index)) + 1
        : 1;
      this.approvalNodes.push({
        index: nextIndex,
        nodeName: `审批节点${nextIndex}`,
        role: 'specificPerson',
        specificUsers: []
      });
    },
    removeNode(index) {
      this.approvalNodes.splice(index, 1);
      this.approvalNodes.forEach((node, i) => { node.index = i + 1; });
    },
    roleChange(index) {
      this.approvalNodes[index].specificUsers = [];
    },
    specificUsersChange(index) {
      const node = this.approvalNodes[index];
      const idSet = new Set((node.specificUsers || []).map(id => String(id)));
      const selectedUsers = this.userList.filter(u => idSet.has(String(u.Id)));
      node.nodeName = selectedUsers.map(u => u.TeacherName).join('、') || node.nodeName;
    },
    submitApprovalNodes() {
      const invalid = this.approvalNodes.find(n =>
        n.role === 'specificPerson' && (!n.specificUsers || !n.specificUsers.length)
      );
      if (invalid) {
        this.$message.error('请为指定人员节点选择审批人');
        return;
      }
      addProcessOfficer({
        processId: this.processId,
        processOfficerDetails: this.approvalNodes.map(node => ({
          index: node.index,
          nodeName: node.nodeName,
          role: node.role,
          specificUsers: (node.specificUsers || []).map(id => String(id)),
          days: 0
        }))
      }).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功');
          this.addApprovalNodeVisible = false;
        } else {
          this.$message.error(res.data.msg || '保存失败');
        }
      });
    }
  }
};
</script>

<style scoped>
.mr-field-tip {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.5;
  color: #94a3b8;
}
.mr-field-tip.inline {
  display: inline-block;
  margin-top: 0;
  margin-left: 8px;
  vertical-align: middle;
}
.mr-approval-scope-hint {
  margin-bottom: 12px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.6;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.mr-approval-scope-hint i {
  margin-right: 6px;
  color: #3b82f6;
}
.mr-approval-scope-hint strong {
  color: #1e293b;
}
.mr-approval-scope-hint span {
  color: #94a3b8;
  font-size: 12px;
}
</style>
